<template>
  <div class="content-container">
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'test',
  data() {
    return {
      imgUrlList: [],
    }
  },
  props: {
    content: String,
  },
  mounted() {
    this.initWeixinJSBridge()
  },
  methods: {
    initWeixinJSBridge() {
      const that = this
      function callback() {
        that.$nextTick(() => {
          that.clickImg()
        })
      }
      if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        callback()
      } else if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', callback, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', callback)
        document.attachEvent('onWeixinJSBridgeReady', callback)
      }
    },
    clickImg() {
      const imgList = document.querySelectorAll('.content-container img')
      if (imgList.length > 0) {
        const that = this
        Array.from(imgList).forEach((img) => {
          const imgUrl = img.getAttribute('src')
          that.imgUrlList.push(imgUrl)
          img.addEventListener(
            'click',
            () => {
              that.imgView(imgUrl)
            },
            false,
          )
        })
      }
    },
    imgView(imgUrl) {
      WeixinJSBridge.invoke(
        'imagePreview',
        {
          current: imgUrl, // 要预览urls中第几张图片的url
          urls: this.imgUrlList,
        },
        (res) => {
          console.log(res)
        },
      )
    },
  },
}
</script>

<style>
.content-container {
  width: 100%;
}
.content-container iframe {
  max-width: 100%;
}
.content-container img {
  width: 100%;
}
</style>
